import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LazyLoadedTableDataSource } from 'src/app/shared/components/mat-table/lazy-loaded.data-source';
import { TriggeredTableDataSource } from 'src/app/shared/components/mat-table/triggered.data-source';

@Component({
  selector: 'shared-table-empty-data',
  templateUrl: './table-empty-data.component.html',
  styleUrl: './table-empty-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableEmptyDataComponent {
  @Input() dataSource: LazyLoadedTableDataSource<any> | TriggeredTableDataSource<any>;
}
